<template > 
	<v-container>
		<v-card>
		  <v-card-title primary-title>
		  	<v-layout row wrap justify-center>
			  	<v-flex md6 text-md-center>
						<h2 class="display-3 indigo--text">Manual de usuario</h2>
			  	</v-flex>
		  	</v-layout>
		  </v-card-title>
		  <v-card-text v-if="!loading">
		  	<v-container id="index">
		    	<h3 class="display-2" >Indice:</h3>
		    	<br>
		    	<div v-for="section in sections">
	  				<v-hover :key="section.name">
	  					<v-row class="unhabilited_padding" text slot-scope="{ hover }" @click="goTo(section.name)">
								<v-flex md6>
			    				<h4 class="display-1 ml-2">
										<v-icon size="10" >fas fa-circle</v-icon>
			    					{{ section.title }}:
			    					<br>
			    				</h4>
								</v-flex md6>
								<v-flex class="text-right">
			    				<v-icon v-if="hover">fas fa-paragraph</v-icon>
								</v-flex>
	  					</v-row>
	  				</v-hover> 
	  				<div class="ml-3" v-for="item in section.items">
		  				<v-hover :key="item.name">
		  					<v-row class="unhabilited_padding" text slot-scope="{ hover }" @click="goTo(item.name)">
									<v-flex md6>
				    				<h5 class="title ml-2">
											<v-icon size="7" >far fa-circle</v-icon>
				    					{{ item.title }}:
				    					<br>
				    				</h5>
									</v-flex>
									<v-flex md6 class="text-right">
				    				<v-icon v-if="hover">fas fa-paragraph</v-icon>
									</v-flex>
		  					</v-row>
		  				</v-hover> 
		  				<div class="ml-3" v-for="content in item.contents">
			  				<v-hover :key="content.name">
			  					<v-row text slot-scope="{ hover }" @click="goTo(content.name)">
										<v-flex md6>
					    				<p class="ml-2">
												<v-icon size="5" >fas fa-circle</v-icon>
					    					{{ content.title }}
					    				</p>
										</v-flex>
										<v-flex md6 class="text-right">
					    				<v-icon v-if="hover">fas fa-paragraph</v-icon>
										</v-flex>
			  					</v-row>
			  				</v-hover> 
		  				</div>
	  				</div>
		    	</div>
		  	</v-container>
		  	<v-divider></v-divider>
		  	<v-container v-for="section in sections" :key="section.name">
		  		<v-card>
		  			<v-card-title>
			  	  	<h3 class="display-2" :id="section.name">
			  	  		{{ section.title }}
			  	  	</h3>
		  			</v-card-title>
			  	  <v-card text>
			  	    <p class="body-1" v-html="section.text"></p>
			  	    <v-container>
			  	      <v-row class="ml-2" v-for="item in section.items">
			  	      	<v-flex md12>
			  	      	  <h4 class="display-1">{{item.title}}</h4>
			  	      	</v-flex>
			  	      	<v-flex md12>
			  	      	  <p class="body-1">{{item.text}}</p>
			  	      	  <v-container>
			  	      	  	<v-row class="ml-2" v-for="content in item.contents">
			  	      	  		<v-flex md12>
			  	      	        <h5 class="headline">{{content.title}}</h5>
			  	      	  		</v-flex>
			  	      	  		<v-flex md12>		
			  	      	        <p class="body-1" v-html="content.content"></p>
			  	      	  		</v-flex>
			  	      	  	</v-row>
			  	      	  </v-container>
			  	      	</v-flex>
			  	      </v-row>
			  	    </v-container>
			  	  </v-card><br>
		  		</v-card>
		  	 	<v-divider></v-divider>
		  	 	<br>
		  	</v-container>
		  </v-card-text>
		  <v-card-text v-else>
		    <v-layout row wrap justify-center>
		      <v-flex xs6 text-md-center>
		        <v-progress-circular indeterminate size="60"></v-progress-circular>
		      </v-flex>
		    </v-layout>
		  </v-card-text>
			<v-fab-transition>
          <v-btn
          	@click="goTo('index')"
            dark
            fixed
            bottom
            right
            fab
          >
            <v-icon >fas fa-angle-up</v-icon>
          </v-btn>
        </v-fab-transition>
		</v-card>
	</v-container>
</template>
<script>
	//import * as easings from 'vuetify/es5/util/easing-patterns'
	export default{
		mounted(){
			this.getData();
		},
		data(){
			return {
				loading: false,
				baseRoute: process.env.VUE_APP_URL + 'api/documentation/',
				sections: [],
				sectionsTwo: [
					{ name: 'Dashboard', target: 'dashboard' },
					{ name: 'Area de estudio', target: 'study'},
					{ name: 'Variables', target: 'vari'},
					{ name: 'Datos espaciales', target: 'data'},
					{ name: 'Usuarios', target:'users' },
					{ name: 'Resultados', target: 'results'},
					{ name: 'Notificaciónes', target: 'notify' },
					{ name: 'Administración web', target: 'admin'},
					{ name: 'Documentación', target: 'documentation'},
					{ name: 'Ayuda', target: 'help'},
					{ name: 'Rutinas', target: 'routines'},
					{ name: 'Estilos', target: 'style'}
				],
				options: {
					duration: 700,
					offset: 0,
					easing: 'easeInOutCubic'
				},
	
				maxHeight: 0
			}
 
		},
		methods: {
			getData(){
				this.loading = true;
				axios.get(this.baseRoute + 'getContent').then((res) => {
					this.loading = false;
					this.sections = res.data;
					this.setMenu();
				}).catch((error) => {
					this.loading = false;
				});
			},
			goTo(target){
				this.$vuetify.goTo('#' + target, this.options)
			},
			setMenu(){
				this.$nextTick(() => {
					let menu = []
					for (var i = 0; i < this.sections.length; i++) {
						menu.push({
							'id': i,
							'to': '#' + this.sections[i].name,
							'text': this.sections[i].title,
							'icon': this.sections[i].icon,
						})
					}
					this.$store.state.api.menu = [
					  {
					    "id": 1,
					    "to": "/dashboard",
					    "text": "Ir a Dashboard",
					    "icon": "mdi-view-dashboard",
					    "submenu": null
					  },
					  {
					    "id": 11,
					    "to": "#!",
					    "text": "Secciones",
					    "icon": "fas fa-book",
					    "submenu": menu
					  }
					];
				})
			}
			
		},
	
	}
</script>
<style>
	.document_img{
		margin-top: 5px;
		max-width: 100%;
	}
</style>